import { Observable, forkJoin, of } from "rxjs";
import { PS_Supplier_Qual_Docs_2_Result, PafDocument, RseQuestion, RseQuestionIndex, RseQuestionsGroup, Supplier, SupplierRseAnswer, SupplierRseAnswersIndex } from "../../../all-models";
import { DocumentsService, PafListsService, SharedDataService, SuppliersService } from "../../../all-services";
import moment from 'moment';
import { RseQualityDoc } from "../../../Models/RseQualityDoc";
import { map, switchMap } from "rxjs/operators";
import { EventEmitter } from "@angular/core";

export class SupplierRseAnswers {

  public valueChanged : EventEmitter<void>  = new EventEmitter<void>();
  public dependencyOffset : number = 15;

  public rseGroups: RseQuestionsGroup[] = [];
  public rseQuestions: RseQuestion[] = []; 
  
  public PendingFiles: Record<number, File>={};

  public get rootsGroups(): RseQuestionsGroup[] {
    let result: RseQuestionsGroup[] = this.rseGroups.filter(g => {
      return g.ParentGroupId == null && this.groupOrQuestionIsVisible(g);
    });
    result.sortObject('DisplayRank');
    return result;
  }
  constructor(
    public supplier: Supplier,
    public sharedSvc: SharedDataService,
    private suppliersSvc: SuppliersService,
    private listsSvc: PafListsService,    
    private docSvc:DocumentsService
  ) {
    forkJoin([
      this.listsSvc.getRseQuestions(),
      this.listsSvc.getRseQuestionsGroups(),
      this.listsSvc.getPafDocuments(),
      this.docSvc.getSupplierQualDocs(this.sharedSvc.lngCod,this.supplier.Id)
    ]).subscribe({
      next: (results) => {
        this.rseQuestions = results[0];
        this.rseGroups = results[1];
        this.isoPafDocs = results[2].filter(pd=>!!pd.RseQualityDoc);
        this.supplierQualityIsoDocs = results[3].filter(d=> d.StatutCod!='ARCHIVE' && !!d.FullPath && this.isoPafDocs.some(pd=>pd.Id==d.RefDocId));
        this.rseGroups.sortObject('DisplayRank');
        this.affecteSupplierAnswers();
        this.onValueChanged();
      }
    })
  }

  onValueChanged():void {
    this.valueChanged.emit();
  }

  isoPafDocs:PafDocument[] = [];
  supplierQualityIsoDocs:PS_Supplier_Qual_Docs_2_Result[]=[];

  affecteSupplierAnswers() {
    if (!this.supplier?.SupplierRseAnswers || this.rseQuestions.length == 0) return;
    this.rseQuestions.forEach(q => {
      let answer: SupplierRseAnswer = this.supplier.SupplierRseAnswers.find(a => a.QuestionId == q.Id)
      if (!answer) {
        answer = new SupplierRseAnswer();
        answer.SupplierId = this.supplier.Id;
        answer.QuestionId = q.Id;
        this.supplier.SupplierRseAnswers.push(answer);
      }
      q.RseQuestionIndexes.forEach(qIdx => {
        let answerIndex: SupplierRseAnswersIndex = answer.SupplierRseAnswersIndexes.find(a => a.IndexId == qIdx.Id);
        if (!answerIndex) {
          answerIndex = new SupplierRseAnswersIndex();
          answerIndex.IndexId = qIdx.Id;
          answerIndex.AnswerId = answer.Id;
          answer.SupplierRseAnswersIndexes.push(answerIndex);
        }
        (<any>answerIndex).DisplayRank = qIdx.DisplayRank; //On met le rang d'affichage de l'index dans l'objet réponse pour trier les réponses selon leur rang d'affichage
      });
    });
}



  groupOrQuestionIsVisible(item: RseQuestionsGroup | RseQuestion): boolean {
    if (!item) return false;
    let parentContainer: RseQuestionsGroup = this.parentContainer(item);
    // Avant tout, on vérifie que le conteneur parent est visible.
    if (!!parentContainer && !this.groupOrQuestionIsVisible(parentContainer)) return false;
    //Le conteneur parent étant visible, la visibilité dépend de la question conditonnelle
    if (item.ConditionalQuestionId != null && item.ConditionalQuestionValue != null) {
      let conditionalQuestion = this.rseQuestions.find(q => q.Id == item.ConditionalQuestionId);
      //Si la question conditionnelle n'est pas visible, on considère que ce qui est dépend ne l'est pas 
      if (!this.groupOrQuestionIsVisible(conditionalQuestion)) return false;
      return this.supplier.SupplierRseAnswers.some(a => a.QuestionId == item.ConditionalQuestionId && a.Answer == item.ConditionalQuestionValue);
    } else {
      return true;
    }
  }


  questionIsVisible(questionId: number): boolean {
    return this.groupOrQuestionIsVisible(this.rseQuestions.find(q => q.Id == questionId));
  }

  parentContainer(item: RseQuestionsGroup | RseQuestion): RseQuestionsGroup | undefined {
    let parentGroupId: number | undefined = (<any>item)['ParentGroupId'] || (<any>item)['GroupId'];
    if (!parentGroupId) return undefined;
    return this.rseGroups.find(g => g.Id == parentGroupId);
  }


  questionAnswer(questionId: number): SupplierRseAnswer | undefined {
    if (!this.supplier?.SupplierRseAnswers) return undefined;
    return this.supplier.SupplierRseAnswers.find(a => a.QuestionId == questionId);
  }


  questionIndex(questionIndexId: number): RseQuestionIndex | undefined {
    return this.rseQuestions.find(q => q.RseQuestionIndexes.find(qi => qi.Id == questionIndexId)).RseQuestionIndexes.find(qi => qi.Id == questionIndexId);
  }

  visibleAnswerIdx(questionId: number): SupplierRseAnswersIndex[] {
    let answer: SupplierRseAnswer = this.questionAnswer(questionId);
    let question: RseQuestion = this.rseQuestions.find(q => q.Id == questionId);
    if (!answer || !question || !this.groupOrQuestionIsVisible(question)) return [];
    return answer.SupplierRseAnswersIndexes.filter(a => {
      let qstIdx: RseQuestionIndex = question.RseQuestionIndexes?.find(i => i.Id == a.IndexId);
      if (!qstIdx || qstIdx.ConditionalQuestionValue == null) return false;
      return answer.Answer == qstIdx.ConditionalQuestionValue;
    });
  }

  //Pour être sauvegardé, il ne doit pas y avoir de question visible sans réponse ou avec un index obligatoire vide.
  get canSave(): boolean {
    let invalidAnswers:SupplierRseAnswer[] = this.supplier.SupplierRseAnswers
      .filter(a => this.questionIsVisible(a.QuestionId)
        && (a.Answer == undefined
          || a.SupplierRseAnswersIndexes.some(i => this.visibleAnswerIdx(a.QuestionId)
            .some(ai => {
              let rqi: RseQuestionIndex = this.questionIndex(ai.IndexId);
              return rqi.Required == 1 && !ai.Value;
            })
          )));
    return invalidAnswers.length==0;
  }

  save(): Observable<SupplierRseAnswer[]> {
    this.supplier.SupplierRseAnswers.filter(a=>!this.questionIsVisible(a.QuestionId)).forEach(element => {
      element.Answer=null;
    });

    // On met la valeur nulle aux indexes passés en invisibles
    this.supplier.SupplierRseAnswers.filter(a=>a.SupplierRseAnswersIndexes.length>0 && this.visibleAnswerIdx(a.QuestionId).length==0)
    .forEach(answer=>{
        answer.SupplierRseAnswersIndexes
        .forEach(item=>item.Value = null);
      }      
    );

    this.supplier.SupplierRseAnswers.filter(a=>a.SupplierRseAnswersIndexes.some(i=>this.questionIndex(i.IndexId).IndexType=='date'))
    .forEach(answer=>{
        answer.SupplierRseAnswersIndexes.filter(i=> i.Value != null && this.questionIndex(i.IndexId).IndexType=='date')
        .forEach(item=>item.Value = moment(item.Value).format('YYYY/MM/DD'));
      }      
    );
    return this.suppliersSvc.UpdateRseAnswers(this.supplier.Id,this.supplier.SupplierRseAnswers)
    .pipe(map(results=>{
      this.supplier.SupplierRseAnswers = results;
      //Si des reponses / indexes ont été supprimés de la base, on les regenere à vide si besoin de les afficher
      this.affecteSupplierAnswers();
      return results;
    }));    
  }

  sendPendingFiles(answers:SupplierRseAnswer[]):Observable<SupplierRseAnswersIndex[]> {
      let answersIdxWithFile:SupplierRseAnswersIndex[]=[];
      answers.filter(a=>a.SupplierRseAnswersIndexes.some(ai=>!!this.PendingFiles[ai.IndexId]))
        .forEach(a=>{
          answersIdxWithFile = answersIdxWithFile.concat(a.SupplierRseAnswersIndexes.filter(ai=>!!this.PendingFiles[ai.IndexId]));
        });
        if (answersIdxWithFile.length==0) return of([]);
        let results :Observable<SupplierRseAnswersIndex>[] = answersIdxWithFile.map((item:SupplierRseAnswersIndex)=>{
          return this.sendOnePendingFile(item)
          .pipe(map((result:SupplierRseAnswersIndex)=>{
            item.Id = result.Id;
            item.Value = result.Value;
            return result;
          }));
        });
        return forkJoin(results);
  }
  
  questionFullfilled(questionId: number) : boolean{
    if (!this.questionIsVisible(questionId) ) return false;//la question doit être visible
    if ([0,1].indexOf(this.questionAnswer(questionId).Answer)<0) return false; //la question doit avoir une réponse Oui ou Non
    if (this.visibleAnswerIdx(questionId).length==0) return true; //Ok si pas d'index à saisir
    return !this.visibleAnswerIdx(questionId).some(ai=>this.questionIndex(ai.IndexId).Required==1 && !ai.Value); //OK si pas d'index obligatoire non rempli
  }

  answerScore(questionId:number) : number {
    let answer:SupplierRseAnswer = this.questionAnswer(questionId);
    if (!answer || [0,1].indexOf(answer.Answer)<0) return 0;
    let question:RseQuestion = this.rseQuestions.find(q => q.Id == questionId);
    return (answer.Answer==1 ? question.Score : question.NegativeScore) || 0;    
  }

  private sendOnePendingFile(answerIdx: SupplierRseAnswersIndex):Observable<SupplierRseAnswersIndex> {
    let file:File = this.PendingFiles[answerIdx.IndexId];
    return this.suppliersSvc.sendOneRsePendingFile(this.supplier.Id,answerIdx.AnswerId,answerIdx.IndexId,file);   
  }

  get rseIndictateurValue():number {
    let scoredQuestions:RseQuestion[]= this.rseQuestions.filter(q=>this.questionFullfilled(q.Id));
    
    let RseQualityDocs:RseQualityDoc[] = this.supplierQualityIsoDocs.filter(d=>(!!d.DateExpi) && moment().isSameOrBefore(d.DateExpi)).map(sd=>this.isoPafDocs.find(pd=>pd.Id==sd.RefDocId).RseQualityDoc);
    let value = scoredQuestions.length==0 ? 0 :  scoredQuestions.map(q=>(this.answerScore(q.Id)*100)).reduce((sum,score)=>sum + score);
    let valueIso = RseQualityDocs.length==0 ? 0 :  RseQualityDocs.map(d=>(d.Score*100)|0).reduce((sum,score)=>sum + score);
    
    return Math.round(Math.min((value+valueIso)/200,this.sharedSvc.rseMaxValue));
  }
  get rseIndictateurColor():string {    
    let rseValue:number = this.rseIndictateurValue;
    return rseValue<50?'red':(rseValue<=70? 'orange' : 'green');    
  }

  // Demande de Pierre : ajouter un décalage aux questions dépendant d'une autre
  dependencyOffsetLevel(item: RseQuestionsGroup | RseQuestion): number {
    if (!item) return 0;
    if (item.ConditionalQuestionId != null && item.ConditionalQuestionValue != null) {
      let conditionalQuestion = this.rseQuestions.find(q => q.Id == item.ConditionalQuestionId);
      return this.dependencyOffsetLevel(this.parentContainer(conditionalQuestion)) + 1;
    } else {
      return 0;
    }
  }

  ngStyle(item: RseQuestionsGroup | RseQuestion): any {
    return {'margin-left': `${this.dependencyOffset * this.dependencyOffsetLevel(item)}px` };
  }
}